<ng-container *ngIf="triggeredBy">
  <span *ngIf="triggeredBy.origin === 'orchestrator'">
    <fa-icon [icon]="['fal', 'clock']"></fa-icon>
    <span class="ml-1">Scheduler</span>
  </span>

  <y42-user-avatar
    *ngIf="triggeredBy.origin === 'user' && triggeredBy.user"
    [user]="triggeredBy.user"
    [size]="30"
  ></y42-user-avatar>
</ng-container>
